// removed by extract-text-webpack-plugin
module.exports = {"h2":"H2__h2___2RM10"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/H2.scss
// module id = IwVI
// module chunks = 0